export default __webpack_public_path__ + "static/media/avatar-placeholder.9103f94f.svg";